import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ErrorBoundary } from "react-error-boundary";
import { ThemeProvider } from "@anchor/react-components/dist/lib/components";
import { SessionValidationProvider } from "../context/SessionValidationContext";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsalAuthentication,
} from "@azure/msal-react";
import { UserAccessContextProvider } from "../context/UserAccessContext";
import UnAuthenticatedAppBody from "../Components/UnAuthenticatedAppBody/UnAuthenticatedAppBody";
import { AppTourProvider } from "../context/TourContext";
import { InteractionType } from "@azure/msal-browser";
import { BrowserRouter as Router } from "react-router-dom";
import { queryClient } from "../Utils/queryClient";

function Fallback({ error }) {
  return (
    <div
      role="alert"
      style={{
        width: "100%",
        height: "90vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <h2 style={{ textAlign: "center", color: "grey" }}>Error 404</h2>
      <p>Something went wrong, please contact the sre team</p>
      <pre style={{ color: "red" }}>{error.message}</pre>
    </div>
  );
}

export const AppProvider = ({ children }) => {
  useMsalAuthentication(InteractionType.Redirect);

  return (
    <QueryClientProvider client={queryClient}>
      <SessionValidationProvider>
        <ThemeProvider>
          <ErrorBoundary FallbackComponent={Fallback}>
            <AuthenticatedTemplate>
              <UserAccessContextProvider>
                <AppTourProvider>{children}</AppTourProvider>
              </UserAccessContextProvider>
            </AuthenticatedTemplate>
            <ReactQueryDevtools />
            <UnauthenticatedTemplate>
              <UnAuthenticatedAppBody />
            </UnauthenticatedTemplate>
          </ErrorBoundary>
        </ThemeProvider>
      </SessionValidationProvider>
    </QueryClientProvider>
  );
};
